/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import {
    GetClaimHistory,
    GetPVHistoryDetails,
    Getclaimremarksdetails
} from "common/data/mastersapi";

const AllStagesDiscussionModal = ({
    isOpen,
    toggle,
    claimData = null,
    currentUser
}) => {
    const [activeTab, setActiveTab] = useState('CLAIM');
    const [claimHistoryText, setClaimHistoryText] = useState("");
    const [loadingClaim, setLoadingClaim] = useState(false);

    const [pppHistory, setPppHistory] = useState([]);
    const [loadingPPP, setLoadingPPP] = useState(false);

    const [pvHistory, setPvHistory] = useState([]);
    const [loadingPV, setLoadingPV] = useState(false);

    const claimId = claimData?.Claim_ID || claimData?.id || 0;
    const summaryId = claimData?.SummaryId || claimData?.summaryid || claimData?.summary_id || 0;
    const paymentNo = claimData?.PaymentNo || claimData?.paymentno || "";
    const voucherNo = claimData?.voucherno || claimData?.voucher_no || "";

    useEffect(() => {
        if (isOpen && claimId) {
            setActiveTab('CLAIM');
            fetchClaimHistory();
            fetchPppHistory();
            fetchPvHistory();
        } else if (!isOpen) {
            setClaimHistoryText("");
            setPppHistory([]);
            setPvHistory([]);
        }
    }, [isOpen, claimId, summaryId]);

    const fetchClaimHistory = async () => {
        setLoadingClaim(true);
        try {
            const res = await GetClaimHistory(claimId);
            if (res && res.status) {
                setClaimHistoryText(res.data || "");
            } else {
                setClaimHistoryText("");
            }
        } catch (err) {
            console.error("Error fetching claim history:", err);
            setClaimHistoryText("");
        }
        setLoadingClaim(false);
    };

    const extractHistoryItems = (res) => {
        if (!res) return [];
        if (Array.isArray(res)) return res;
        if (Array.isArray(res.data)) return res.data;
        if (Array.isArray(res.Data)) return res.Data;
        if (Array.isArray(res.data?.data)) return res.data.data;
        return [];
    };

    const fetchPppHistory = async () => {
        setLoadingPPP(true);
        try {
            let items = [];
            if (summaryId) {
                const res = await GetPVHistoryDetails(summaryId, currentUser?.branchid || 1, currentUser?.orgid || 1);
                items = extractHistoryItems(res);
            }
            if ((!items || items.length === 0) && claimId) {
                const resRemarks = await Getclaimremarksdetails(claimId);
                items = extractHistoryItems(resRemarks);
            }
            setPppHistory(items || []);
        } catch (err) {
            console.error("Error fetching PPP history:", err);
            setPppHistory([]);
        }
        setLoadingPPP(false);
    };

    const fetchPvHistory = async () => {
        setLoadingPV(true);
        try {
            let items = [];
            if (summaryId) {
                const res = await GetPVHistoryDetails(summaryId, currentUser?.branchid || 1, currentUser?.orgid || 1);
                items = extractHistoryItems(res);
            }
            if ((!items || items.length === 0) && claimId) {
                const resRemarks = await Getclaimremarksdetails(claimId);
                items = extractHistoryItems(resRemarks);
            }
            setPvHistory(items || []);
        } catch (err) {
            console.error("Error fetching PV history:", err);
            setPvHistory([]);
        }
        setLoadingPV(false);
    };

    const parseHistoryText = (text) => {
        if (!text) return [];
        const lines = text.split('\n');
        const messages = [];
        const regex = /^\[(.*?)\sat\s(.*?)\]:\s(.*)$/;

        lines.forEach((line) => {
            const match = line.match(regex);
            if (match) {
                messages.push({
                    senderName: match[1],
                    timestamp: match[2],
                    messageContent: match[3]
                });
            } else {
                if (messages.length > 0) {
                    messages[messages.length - 1].messageContent += '\n' + line;
                } else if (line.trim() !== "") {
                    messages.push({
                        senderName: "Unknown",
                        timestamp: "",
                        messageContent: line
                    });
                }
            }
        });
        return messages;
    };

    const formatDateTime = (logDate, logTime) => {
        let dateStr = (logDate || "").trim();
        let timeStr = (logTime || "").trim();
        let displayDateTime = dateStr;
        if (dateStr && timeStr && !dateStr.includes(timeStr) && !dateStr.includes(':')) {
            displayDateTime += " " + timeStr;
        } else if (!dateStr && timeStr) {
            displayDateTime = timeStr;
        }
        if (displayDateTime) {
            try {
                let parseStr = displayDateTime;
                if (!parseStr.includes('Z') && !parseStr.includes('UTC') && !parseStr.match(/[+-]\d{2}:\d{2}/)) {
                    parseStr += ' UTC';
                }
                const d = new Date(parseStr);
                if (!isNaN(d.getTime())) {
                    return d.toLocaleString('en-GB', {
                        timeZone: 'Asia/Jakarta',
                        day: '2-digit',
                        month: 'short',
                        year: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit',
                        second: '2-digit',
                        hour12: false
                    }).replace(',', '');
                }
            } catch (e) {
                // fallback
            }
        }
        return displayDateTime;
    };

    const renderLogChatBubbles = (items, emptyMessage) => {
        if (!items || items.length === 0) {
            return (
                <div className="text-center p-4 text-muted">
                    <i className="mdi mdi-chat-outline text-muted" style={{ fontSize: "2rem" }}></i>
                    <p className="mt-2 mb-0">{emptyMessage || "No discussion history recorded."}</p>
                </div>
            );
        }

        return items.map((item, index) => {
            const getField = (obj, ...keys) => {
                for (const key of keys) {
                    if (obj[key] !== undefined && obj[key] !== null) return obj[key];
                    const found = Object.keys(obj).find(k => k.toLowerCase() === key.toLowerCase());
                    if (found && obj[found] !== undefined && obj[found] !== null) return obj[found];
                }
                return "";
            };

            const senderName = getField(item, "username", "Username", "UserName", "user_name", "applicantname", "name", "FullName") || "Unknown";
            const logDate = getField(item, "logdate", "LogDate", "log_date", "createddate", "CreatedDate", "transactiondate");
            const logTime = getField(item, "logtime", "LogTime", "log_time");
            const comment = getField(item, "claim_comment", "Claim_Comment", "ClaimComment", "comment", "Comment", "remarks", "Remarks");

            const currentUserName = currentUser?.username || currentUser?.FullName || "";
            const isMe = currentUserName && senderName?.toLowerCase() === currentUserName.toLowerCase();

            return (
                <div key={index} className={`d-flex ${isMe ? 'justify-content-end' : 'justify-content-start'} mb-3`}>
                    <div
                        className="p-3 shadow-sm"
                        style={{
                            maxWidth: '75%',
                            borderRadius: '15px',
                            backgroundColor: isMe ? '#5b73e8' : '#ffffff',
                            color: isMe ? '#ffffff' : '#000000',
                            borderBottomRightRadius: isMe ? '0' : '15px',
                            borderBottomLeftRadius: !isMe ? '0' : '15px'
                        }}
                    >
                        <div className="d-flex justify-content-between align-items-center mb-1">
                            <small className="fw-bold me-3" style={{ opacity: 0.9 }}>{senderName}</small>
                            <small style={{ fontSize: '0.75rem', opacity: 0.8 }}>
                                {formatDateTime(logDate, logTime)}
                            </small>
                        </div>
                        <p className="mb-0" style={{ whiteSpace: 'pre-wrap', fontFamily: 'Inter, sans-serif', fontSize: '14px' }}>
                            {comment || "(No comment)"}
                        </p>
                    </div>
                </div>
            );
        });
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} size="lg" centered>
            <ModalHeader toggle={toggle}>
                <div className="d-flex align-items-center gap-2">
                    <span>Discussion Chats</span>
                    {(claimData?.ApplicationNo || claimData?.claimno || claimId) && (
                        <span className="badge bg-soft-primary text-primary" style={{ fontSize: "12px", fontWeight: "normal" }}>
                            Claim #{claimData?.ApplicationNo || claimData?.claimno || claimId}
                        </span>
                    )}
                </div>
            </ModalHeader>

            {/* Stage Tabs Navigation */}
            <div className="px-3 pt-2 border-bottom bg-white">
                <ul className="nav nav-tabs nav-tabs-custom nav-justified" role="tablist">
                    <li className="nav-item">
                        <button
                            type="button"
                            className={`nav-link ${activeTab === 'CLAIM' ? 'active text-primary fw-bold' : 'text-muted'}`}
                            style={{ cursor: 'pointer', border: 'none', borderBottom: activeTab === 'CLAIM' ? '3px solid #5b73e8' : 'none' }}
                            onClick={() => setActiveTab('CLAIM')}
                        >
                            <i className="mdi mdi-comment-account-outline me-1"></i> Claim Discussion
                        </button>
                    </li>
                    <li className="nav-item">
                        <button
                            type="button"
                            className={`nav-link ${activeTab === 'PPP' ? 'active text-warning fw-bold' : 'text-muted'}`}
                            style={{ cursor: 'pointer', border: 'none', borderBottom: activeTab === 'PPP' ? '3px solid #f1b44c' : 'none' }}
                            onClick={() => setActiveTab('PPP')}
                        >
                            <i className="mdi mdi-clipboard-text-outline me-1"></i> PPP Discussion
                            {paymentNo ? (
                                <span className="badge bg-soft-warning text-warning ms-1" style={{ fontSize: '10px' }}>
                                    {paymentNo}
                                </span>
                            ) : null}
                        </button>
                    </li>
                    <li className="nav-item">
                        <button
                            type="button"
                            className={`nav-link ${activeTab === 'PV' ? 'active text-info fw-bold' : 'text-muted'}`}
                            style={{ cursor: 'pointer', border: 'none', borderBottom: activeTab === 'PV' ? '3px solid #50a5f1' : 'none' }}
                            onClick={() => setActiveTab('PV')}
                        >
                            <i className="mdi mdi-receipt-outline me-1"></i> PV Discussion
                            {voucherNo ? (
                                <span className="badge bg-soft-info text-info ms-1" style={{ fontSize: '10px' }}>
                                    {voucherNo}
                                </span>
                            ) : null}
                        </button>
                    </li>
                </ul>
            </div>

            <ModalBody style={{ maxHeight: '60vh', overflowY: 'auto', backgroundColor: '#f8f9fa' }}>
                {/* 1. Claim Discussion Tab */}
                {activeTab === 'CLAIM' && (
                    <div className="history-container p-3">
                        {loadingClaim ? (
                            <div className="text-center p-4">Loading Claim discussion...</div>
                        ) : (
                            (() => {
                                const parsed = parseHistoryText(claimHistoryText);
                                if (parsed.length === 0) {
                                    return (
                                        <div className="text-center p-4 text-muted">
                                            <i className="mdi mdi-chat-outline text-muted" style={{ fontSize: "2rem" }}></i>
                                            <p className="mt-2 mb-0">No discussion history recorded for this Claim yet.</p>
                                        </div>
                                    );
                                }

                                return parsed.map((msg, index) => {
                                    const { senderName, timestamp, messageContent } = msg;
                                    let isMe = false;
                                    const currentUserName = currentUser?.username || currentUser?.FullName;
                                    if (currentUserName && senderName.toLowerCase() === currentUserName.toLowerCase()) {
                                        isMe = true;
                                    }

                                    return (
                                        <div key={index} className={`d-flex ${isMe ? 'justify-content-end' : 'justify-content-start'} mb-3`}>
                                            <div
                                                className="p-3 shadow-sm"
                                                style={{
                                                    maxWidth: '75%',
                                                    borderRadius: '15px',
                                                    backgroundColor: isMe ? '#5b73e8' : '#ffffff',
                                                    color: isMe ? '#ffffff' : '#000000',
                                                    borderBottomRightRadius: isMe ? '0' : '15px',
                                                    borderBottomLeftRadius: !isMe ? '0' : '15px'
                                                }}
                                            >
                                                <div className="d-flex justify-content-between align-items-center mb-1">
                                                    <small className="fw-bold me-3" style={{ opacity: 0.9 }}>{senderName}</small>
                                                    {timestamp && <small style={{ fontSize: '0.75rem', opacity: 0.8 }}>{timestamp}</small>}
                                                </div>
                                                <p className="mb-0" style={{ whiteSpace: 'pre-wrap', fontFamily: 'Inter, sans-serif', fontSize: '14px' }}>
                                                    {messageContent}
                                                </p>
                                            </div>
                                        </div>
                                    );
                                });
                            })()
                        )}
                    </div>
                )}

                {/* 2. PPP Discussion Tab */}
                {activeTab === 'PPP' && (
                    <div className="history-container p-3">
                        {!summaryId && !paymentNo ? (
                            <div className="text-center p-4">
                                <i className="mdi mdi-information-outline text-muted" style={{ fontSize: "2.5rem" }}></i>
                                <h6 className="mt-2 text-muted">No Periodic Payment Plan (PPP)</h6>
                                <p className="text-muted small mb-0">This claim has not been included in a Payment Plan yet.</p>
                            </div>
                        ) : loadingPPP ? (
                            <div className="text-center p-4">Loading PPP discussion...</div>
                        ) : (
                            renderLogChatBubbles(pppHistory, "No discussion history recorded for this PPP.")
                        )}
                    </div>
                )}

                {/* 3. PV Discussion Tab */}
                {activeTab === 'PV' && (
                    <div className="history-container p-3">
                        {!voucherNo ? (
                            <div className="text-center p-4">
                                <i className="mdi mdi-information-outline text-muted" style={{ fontSize: "2.5rem" }}></i>
                                <h6 className="mt-2 text-muted">No Payment Voucher (PV)</h6>
                                <p className="text-muted small mb-0">Payment Voucher has not been generated for this claim yet.</p>
                            </div>
                        ) : loadingPV ? (
                            <div className="text-center p-4">Loading PV discussion...</div>
                        ) : (
                            renderLogChatBubbles(pvHistory, "No discussion history recorded for this Payment Voucher.")
                        )}
                    </div>
                )}
            </ModalBody>

            <ModalFooter>
                <Button color="secondary" onClick={toggle} outline>Close</Button>
            </ModalFooter>
        </Modal>
    );
};

export default AllStagesDiscussionModal;
